declare namespace $ {

	type $mol_view__sub_shm_prereleasefixtureapp_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_prereleasefixtureapp_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_prereleasefixtureapp extends $mol_view {
		Title( ): $mol_view
		message( ): string
		Message( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map